export default {
    PtSliderRange: {
        invalidTip: 'Invalid data or out of data range',
    },
};
